import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { OTHER_PROPS, UNIFORM_PROPS } from 'common/constants/component-props';
import { defaultProps } from './constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const overlay = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.OVERLAY> =>
	createModel({
		type: COMPONENT_TYPE.OVERLAY,
		editorProps: {
			expandable: true,
		},
		componentProps: {
			[UNIFORM_PROPS.overlayType]: defaultProps.overlayType,
			[UNIFORM_PROPS.overlayShowOn]: defaultProps.overlayShowOn,
			[UNIFORM_PROPS.overlayTriggers]: defaultProps.overlayTriggers,
			styles: {},
			other: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[OTHER_PROPS.overlay.overlayBackdrop]: defaultProps.overlayBackdrop,
						[OTHER_PROPS.overlay.overlayBackdropVisible]: defaultProps.overlayBackdropVisible,
						[OTHER_PROPS.overlay.overlayVisible]: defaultProps.overlayVisible,
						[OTHER_PROPS.overlay.overlayAnimationPreset]: defaultProps.overlayAnimationPreset,
					},
				},
			},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.OVERLAY>;
